<template>
  <div
      class="templatesPanel tw-bg-solBlack tw-border-1 tw-border-b-0 tw-border-borderLight20 tw-border-solid tw-rounded-tl-2xl tw-rounded-tr-2xl tw-mx-2 lg:tw-mx-4"
      :class="{ visible: showTemplatesPanel }"
  >
    <div class="tw-flex tw-justify-between tw-p-4">
      <h3 class="tw-m-0 tw-text-white tw-font-semibold">{{ $t("chooseTemplate") }}</h3>
      <img
          :src="getAssetPath('/assets/images/collapseIcon.svg')"
          :alt="$t('closeButton')"
          class="tw-cursor-pointer hover:tw-opacity-70 tw-transition-opacity"
          @click="$emit('showTemplatesPanel', false)"
      />
    </div>

    <div class="tw-flex tw-mx-4 tw-mb-2 tw-gap-10 tw-overflow-x-scroll tw-pb-4">
      <div
          v-for="(template, index) in templates"
          :key="index"
          class="tw-flex tw-flex-col tw-w-[200px] tw-cursor-pointer"
          @click="$emit('onTemplateSelected', template)"
      >
        <h5 class="tw-mb-3 tw-font-medium tw-text-white">{{ template.name }}</h5>
        <div
            class="tw-w-full tw-rounded-xl tw-border-2 tw-border-solid tw-border-borderLight20 tw-overflow-hidden tw-transition-all hover:tw-border-borderLight40 hover:tw-shadow-lg tw-p-2"
            :style="{ aspectRatio: canvasAspectRatio }"
        >
          <img
              :src="template.preview"
              :alt="$t('template')"
              class="tw-w-full tw-h-full tw-object-cover"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from "vue";
import { getAssetPath } from "@/utils/assetPath";
import { getTemplates } from "@/services/api";
import { canvasAspectRatio } from "@/constants/canvas";

export default {
  setup() {
    return {
      getAssetPath,
      canvasAspectRatio,
    };
  },
  props: {
    showTemplatesPanel: {
      required: true,
      type: Boolean,
    },
    token: {
      required: false,
      type: String,
      default: "",
    },
    config: {
      required: true,
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      templates: [],
    };
  },
  mounted() {
    this.getTemplates();

    nextTick();
  },
  methods: {
    async getTemplates() {
      this.templates = [];

      try {
        this.templates = await getTemplates();
        this.$emit('templatesLoaded', this.templates.length > 0);
        this.$forceUpdate();
      } catch (error) {
        console.error("Error loading templates:", error);
        this.$emit('templatesLoaded', false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#cardDesigner {
  .templatesPanel {
    position: absolute;
    bottom: 0px;
    left: 0;
    right: 0;
    z-index: 300;
    transform: translateY(100%);
    transition: all 500ms;

    &.visible {
      transform: translateY(0);
    }

    &.cursor-pointer {
      cursor: pointer;
    }
  }
}
</style>
